<!-- Transaction History Table -->
<div class="card shadow-sm">
  <div
    class="card-header bg-primary text-white d-flex justify-content-between align-items-center"
  >
    <h5 class="mb-0">Enterprise Branch Requests</h5>
  </div>
  <!-- Tabs -->
  <!-- Status Tabs -->
  <!-- <ul class="nav nav-tabs">
    <li class="nav-item">
      <a
        class="nav-link"
        [class.active]="selectedTab === 1"
        (click)="changeTab(1)"
        style="cursor: pointer"
      >
        Pending
      </a>
    </li>

    <li class="nav-item">
      <a
        class="nav-link"
        [class.active]="selectedTab === 2"
        (click)="changeTab(2)"
        style="cursor: pointer"
      >
        Approved
      </a>
    </li>

    <li class="nav-item">
      <a
        class="nav-link"
        [class.active]="selectedTab === 3"
        (click)="changeTab(2)"
        style="cursor: pointer"
      >
        Rejected
      </a>
    </li>
  </ul> -->

  <div class="card-body p-0">
    <div class="table-responsive">
      <table
        class="table table-bordered table-hover mb-0"
        id="transactionTable"
      >
        <thead class="">
          <tr>
            <th>Company Code</th>
            <th>Branch Name</th>
            <th>Owner</th>
            <th>Address</th>
            <th>Action</th>
          </tr>
        </thead>

        <tbody>
          <tr class="fw-bold" *ngFor="let data of enterpriseBranchRequests">
            <td>{{ data.companyCode }}</td>
            <td>
              {{ data.branchName }}
            </td>
            <td>
              {{ data.ownerDetails.firstName }} {{ data.ownerDetails.lastName }}
            </td>
            <td>{{ data.address }}</td>

            <!-- ⭐ ACTION DROPDOWN -->
            <td class="text-center">
              <div ngbDropdown class="d-inline-block">
                <button
                  class="btn btn-sm btn-primary dropdown-toggle"
                  ngbDropdownToggle
                >
                  Action
                </button>

                <div ngbDropdownMenu>
                  <button
                    class="dropdown-item"
                    (click)="openViewModal(viewModal, data)"
                  >
                    👁️ View
                  </button>

                  <button
                    class="dropdown-item"
                    (click)="updateRequest(data._id, 2)"
                  >
                    ✔️ Approve
                  </button>

                  <button
                    class="dropdown-item"
                    (click)="updateRequest(data._id, 3)"
                  >
                    ❌ Reject
                  </button>
                </div>
              </div>
            </td>
          </tr>
          <div
            *ngIf="enterpriseBranchRequests?.length == 0"
            class="text-center mt-2 mb-2"
          >
            <span class="text-danger">Data Not found</span>
          </div>
        </tbody>
      </table>
    </div>

    <ngb-pagination
      (pageChange)="gty((page = $event))"
      [collectionSize]="totalItems"
      [(page)]="page"
      [pageSize]="itemsPerPage"
      [maxSize]="3"
      [rotate]="true"
      [boundaryLinks]="false"
    >
    </ngb-pagination>
  </div>
</div>

<ng-template #viewModal let-modal>
  <div class="modal-content border-0 shadow-lg">
    <!-- HEADER -->
    <div class="modal-header border-0">
      <div>
        <h5 class="modal-title fw-bold mb-0">Branch Details</h5>
        <small class="text-muted">Enterprise branch information</small>
      </div>
      <button
        type="button"
        class="btn-close"
        aria-label="Close"
        (click)="modal.dismiss()"
      ></button>
    </div>

    <!-- BODY -->
    <div class="modal-body px-4 py-3">
      <!-- BASIC INFO -->
      <div class="card mb-3 border-0 shadow-sm">
        <div class="card-body">
          <div class="row g-3">
            <div class="col-md-4">
              <small class="text-muted">Company Code</small>
              <div class="fw-semibold fs-6">
                {{ selectedBranch?.companyCode }}
              </div>
            </div>

            <div class="col-md-4">
              <small class="text-muted">Branch Name</small>
              <div class="fw-semibold fs-6">
                {{ selectedBranch?.branchName }}
              </div>
            </div>

            <div class="col-md-4">
              <small class="text-muted">GST Number</small>
              <div class="fw-semibold">{{ selectedBranch?.gstNumber }}</div>
            </div>

            <div class="col-md-4">
              <small class="text-muted">City</small>
              <div>{{ selectedBranch?.city }}</div>
            </div>

            <div class="col-md-4">
              <small class="text-muted">State</small>
              <div>{{ selectedBranch?.state }}</div>
            </div>

            <div class="col-md-4">
              <small class="text-muted">Address</small>
              <div>{{ selectedBranch?.address }}</div>
            </div>
          </div>
        </div>
      </div>

      <!-- BUSINESS INFO -->
      <div class="card mb-3 border-0 shadow-sm">
        <div class="card-body">
          <h6 class="fw-bold mb-3">Business Details</h6>
          <div class="row g-3">
            <div class="col-md-4">
              <small class="text-muted">Trips</small>
              <div class="fw-semibold">{{ selectedBranch?.noOfTrips }}</div>
            </div>

            <div class="col-md-4">
              <small class="text-muted">Frequency</small>
              <div class="fw-semibold">{{ selectedBranch?.frequency }}</div>
            </div>

            <div class="col-md-4">
              <small class="text-muted">Status</small>
              <div>
                <span
                  class="badge px-3 py-2"
                  [ngClass]="{
                    'bg-warning text-dark': selectedBranch?.status === 1,
                    'bg-success': selectedBranch?.status === 2,
                    'bg-danger': selectedBranch?.status === 3
                  }"
                >
                  {{
                    selectedBranch?.status === 1
                      ? "Pending"
                      : selectedBranch?.status === 2
                      ? "Approved"
                      : "Rejected"
                  }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- OWNER & BANK -->
      <div class="row g-3 mb-3">
        <div class="col-md-6">
          <div class="card border-0 shadow-sm">
            <div class="card-body">
              <h6 class="fw-bold mb-3">Owner Details</h6>
              <p class="mb-1">
                <strong>Name:</strong>
                {{ selectedBranch?.ownerDetails?.firstName }}
                {{ selectedBranch?.ownerDetails?.lastName }}
              </p>
              <p class="mb-0">
                <strong>Phone:</strong>
                {{ selectedBranch?.ownerDetails?.phoneNumber }}
              </p>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="card border-0 shadow-sm">
            <div class="card-body">
              <h6 class="fw-bold mb-3">Bank Details</h6>
              <p class="mb-1">
                <strong>Bank:</strong> {{ selectedBranch?.bankName }}
              </p>
              <p class="mb-1">
                <strong>Account:</strong>
                {{ selectedBranch?.bankAccountNumber }}
              </p>
              <p class="mb-0">
                <strong>IFSC:</strong> {{ selectedBranch?.bankIfscCode }}
              </p>
            </div>
          </div>
        </div>
      </div>

      <!-- UPI & QR -->
      <div class="card border-0 shadow-sm">
        <div class="card-body">
          <div class="row align-items-center">
            <div class="col-md-6">
              <small class="text-muted">UPI ID</small>
              <div class="fw-semibold">{{ selectedBranch?.upiId }}</div>
            </div>

            <div class="col-md-6 text-center">
              <small class="text-muted d-block mb-2">QR Code</small>
              <img
                [src]="selectedBranch?.qrCode"
                class="img-fluid rounded shadow-sm"
                style="max-height: 130px"
              />
            </div>
          </div>
        </div>
      </div>

      <!-- META -->
      <div class="row mt-3 text-muted small">
        <div class="col-md-6">
          Created: {{ selectedBranch?.createdAt | date : "medium" }}
        </div>
        <div class="col-md-6 text-md-end">
          Updated: {{ selectedBranch?.updatedAt | date : "medium" }}
        </div>
      </div>
    </div>
  </div>
</ng-template>
